/**
 * Čuva izabrani jezik u cookie-u kako bi preživeo logout
 * (localStorage se briše pri logout-u, cookie ostaje).
 * i18next LanguageDetector koristi cookie "i18next" pri učitavanju.
 */
const COOKIE_NAME = 'i18next';
const MAX_AGE_DAYS = 365;

export function setLanguageCookie(lng) {
  if (typeof document === 'undefined' || !lng) return;
  const maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
    lng,
  )};path=/;max-age=${maxAge};SameSite=Lax`;
}

export function getLanguageFromCookie() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(
    new RegExp(`(^| )${COOKIE_NAME}=([^;]+)`),
  );
  return match ? decodeURIComponent(match[2]) : null;
}
